{
  "version": 1,
  "asset_id": "17734c8f-1702-41de-990a-fbeab685633d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/17734c8f-1702-41de-990a-fbeab685633d/sleeve-to-bypass-completed-es-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/17734c8f-1702-41de-990a-fbeab685633d/sleeve-to-bypass-completed-es-320.webp",
  "original_filename": "sleeve-to-bypass-completed-es-320.webp",
  "size": 13526,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:46:41Z"
}
